export default __webpack_public_path__ + "static/media/tandoor-glyph-16px.fbb8ec7e.svg";